// extracted by mini-css-extract-plugin
export default {"button":"Button_button__-3R7F","contained":"Button_contained__9pBeh","outlined":"Button_outlined__JXZHa","danger":"Button_danger__x-vHX","cancel":"Button_cancel__0Fy09"};